import { Language } from './lingui.constants';

// Bare language subtags CiaF serves under a URL prefix (e.g. /fr/), not full locales.
export const CIAF_LANGUAGE_PREFIXES = [
  Language.En,
  Language.De,
  Language.Es,
  Language.Fr,
  Language.Nl,
] as const;

export type CiaFLanguagePrefix = (typeof CIAF_LANGUAGE_PREFIXES)[number];

const CIAF_LANGUAGE_PREFIX_SET: ReadonlySet<string> = new Set(CIAF_LANGUAGE_PREFIXES);

export function isCiaFLanguagePrefix(value: string): value is CiaFLanguagePrefix {
  return CIAF_LANGUAGE_PREFIX_SET.has(value);
}
